import { ClientDto, PurchaseOrderDto, SpecializedOrderStatus } from '../../api/ClientApi';

export const filterPurchaseOrders = (
    orders: PurchaseOrderDto[],
    orderDocumentCodeFilter: string,
    destinationFilter: string,
    clientFilter: string,
    clients: ClientDto[],
): PurchaseOrderDto[] => {
    return orders
        .filter((o) => {
            const trimmedDocumentCodeFilter = orderDocumentCodeFilter.trim().toLowerCase();
            if (trimmedDocumentCodeFilter === '') {
                return true;
            }
            return o.documentCode?.toLowerCase().includes(trimmedDocumentCodeFilter);
        })
        .filter((o) => {
            const trimmedDestinationFilter = destinationFilter.trim().toLowerCase();
            if (trimmedDestinationFilter === '') {
                return true;
            }
            return o.destinationSite?.name?.toLowerCase().includes(trimmedDestinationFilter);
        })
        .filter((o) => {
            const trimmedClientFilter = clientFilter.trim().toLowerCase();

            if (trimmedClientFilter === '') {
                return true;
            }

            const client = clients.find((c) => !!o.goods && !!o.goods[0] && c.id === o.goods[0].batch?.supplierId);

            if (!!client) {
                if (
                    !!client.shortName?.toLowerCase().includes(trimmedClientFilter) ||
                    !!client.name?.toLowerCase().includes(trimmedClientFilter)
                ) {
                    return true;
                }
            }

            return false;
        });
};

export const getColorForSpecializedOrderStatus = (orderStatus: SpecializedOrderStatus) => {
    switch (orderStatus) {
        case SpecializedOrderStatus.Created:
            return 'default';
        case SpecializedOrderStatus.InProgress:
            return 'primary';
        case SpecializedOrderStatus.Closed:
            return 'success';
        case SpecializedOrderStatus.Delivered:
            return 'secondary';
        case SpecializedOrderStatus.Cancelled:
            return 'error';
        default:
            return 'error';
    }
};
